import React, { useState } from "react";

// Slike koje koristiš
import Image1 from "../../../Assets/Images/Cabin1.jpg";
import Image2 from "../../../Assets/Images/oskar-kadaksoo-GWtETE5mpdE-unsplash.jpg";
import Image3 from "../../../Assets/Images/Interiror3.jpg";
import Image4 from "../../../Assets/Images/Interiror2.jpg";
import Image5 from "../../../Assets/Images/Interiror1.jpg";

const images = [Image1, Image2, Image3, Image4, Image5];

const HomeImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleImageClick = (index) => {
    setModalImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const modalNext = () => {
    setModalImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const modalPrev = () => {
    setModalImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="slider-container">
      {/* Wrapper za slike */}
      <div className="slider-wrapper">
        {images.map((src, index) => {
          const isCurrent = index === currentIndex;
          const isPrev =
            index === (currentIndex - 1 + images.length) % images.length;
          const isNext = index === (currentIndex + 1) % images.length;
          const isLeftMost =
            index === (currentIndex - 2 + images.length) % images.length;
          const isRightMost = index === (currentIndex + 2) % images.length;

          return (
            <img
              key={index}
              src={src}
              alt={`Slide ${index + 1}`}
              className={`slider-image ${
                isCurrent
                  ? "current"
                  : isPrev
                  ? "previous"
                  : isNext
                  ? "next"
                  : isLeftMost
                  ? "left-most"
                  : isRightMost
                  ? "right-most"
                  : "hidden"
              }`}
              onClick={() => isCurrent && handleImageClick(index)}
            />
          );
        })}

        {/* Strelice za navigaciju */}
        <button onClick={handlePrev} className="slider-arrow-left">
          <i className="fi fi-rr-arrow-small-left"></i>
        </button>
        <button onClick={handleNext} className="slider-arrow-right">
          <i className="fi fi-rr-arrow-small-right"></i>
        </button>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // Sprečava zatvaranje pri kliku unutar modala
          >
            <button onClick={closeModal} className="modal-close-button">
              <i className="fi fi-rr-cross-small"></i>
            </button>
            <img
              src={images[modalImageIndex]}
              alt={`Modal Slide ${modalImageIndex + 1}`}
              className="modal-image"
            />
            {/* Strelice u modalu */}
            <button onClick={modalPrev} className="modal-arrow-left">
              <i className="fi fi-rr-arrow-small-left"></i>
            </button>
            <button onClick={modalNext} className="modal-arrow-right">
              <i className="fi fi-rr-arrow-small-right"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeImageSlider;
